import React from "react";

interface FormSectionProps {
  title: string;
  subtitle?: string;
  description?: string;
  titleRight?: React.ReactNode;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ title, subtitle, description, titleRight, children }) => {
  const sub = subtitle || description;
  return (
    <div style={{ borderBottom: "1px solid var(--divider, #E8EAF0)", paddingBottom: "24px", marginBottom: "24px" }}>
      <div style={{ marginBottom: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: titleRight ? "space-between" : undefined }}>
          <h3 style={{ fontSize: "14px", fontWeight: 600, color: "var(--t1, #1A1D2E)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", margin: 0, lineHeight: "20px" }}>{title}</h3>
          {titleRight}
        </div>
        {sub && <p style={{ fontSize: "12px", color: "var(--t3, #9CA3B8)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", margin: "4px 0 0 0", lineHeight: "16px" }}>{sub}</p>}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>{children}</div>
    </div>
  );
};

export default FormSection;
